import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ConfirmationDialog, ConfirmationDialogDefinition} from '@aviary/dialogs/confirmation-dialog/confirmation-dialog.types';
import {CatalogRecord} from '@store/catalog/catalog.types';
import {CatalogSelectors} from '@store/catalog/catalog.selectors';
import {ConfirmationDialogComponent} from '@aviary/dialogs/confirmation-dialog/confirmation-dialog.component';
import {CombinedCoverImageAndContentComponent} from '@aviary/components/combined-cover-image-and-content/combined-cover-image-and-content.component';
import {SelectPipe} from '@aviary/pipes/select.pipe';

export interface DeleteFavoriteConfirmationData {
  favorite: CatalogRecord;
}

@Component({
  selector: 'px-delete-favorite',
  template: `
    <mx-confirmation-dialog [definition]="dialogDefinition">
      <div class="flex flex-row items-start gap-2 w-full">
        <mx-combined-cover-image-and-content [catalogRecord]="dialogData.favorite" [coverWidthRem]="8.75" [coverHeightRem]="8.75" [coverXPaddingRem]="0.5"
                                             [coverYPaddingRem]="0" class="w-full">
          <div class="flex-col gap-1 h-full justify-center justify-items-center">
            <div class="text-title-large"> {{ statelessSelectors.titleFor(dialogData.favorite) | select }}</div>
            <div class="text-body-large">{{ statelessSelectors.materialTypeDescriptionFor(dialogData.favorite) | select }}</div>
          </div>
        </mx-combined-cover-image-and-content>
      </div>
    </mx-confirmation-dialog>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ConfirmationDialogComponent, CombinedCoverImageAndContentComponent, SelectPipe]
})
export class DeleteFavoriteDialog implements ConfirmationDialog<DeleteFavoriteConfirmationData> {

  public readonly dialogData: DeleteFavoriteConfirmationData = inject(MAT_DIALOG_DATA);
  public readonly statelessSelectors = CatalogSelectors.Stateless;

  public readonly dialogDefinition: ConfirmationDialogDefinition = {
    title: 'Remove from Favorites',
    prompt: 'Are you sure you wish to remove this title from your Favorites?',
    confirmButtonLabel: 'Yes, Remove'
  };
}
